import "./navigation.js";
import "./show-modal.ts";
import "./filter.ts";
import "./hotel-booking.js";
// Donation module loaded dynamically when needed
let donationModulePromise = null;

function loadDonationModule() {
  if (!donationModulePromise) {
    donationModulePromise = import("./donate/index.tsx");
  }
  return donationModulePromise;
}

function waitForDonationModal(callback, maxAttempts = 50) {
  let attempts = 0;
  const check = () => {
    attempts++;
    // Check if the modal element exists (React has mounted)
    if (document.querySelector(".modal-donate")) {
      callback();
    } else if (attempts < maxAttempts) {
      setTimeout(check, 50);
    }
  };
  check();
}

function openDonationModal(detail) {
  loadDonationModule().then(() => {
    waitForDonationModal(() => {
      document.dispatchEvent(new CustomEvent("openDonationModal", { detail }));
    });
  });
}

function openModalFromHash() {
  if (window.location.hash === "#donate") {
    openDonationModal({ amount: null, triggerElement: null });
  }
  if (window.location.hash === "#manage-donation") {
    openDonationModal({ mode: "manage", triggerElement: null });
  }
}

// Set up donation button click handlers for lazy loading
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("[data-donation]").forEach((donateButton) => {
    donateButton.addEventListener("click", (e) => {
      e.preventDefault();
      openDonationModal({
        amount: donateButton.getAttribute("data-amount") || null,
        triggerElement: donateButton,
      });
    });
  });

  // Check for #donate / #manage-donation anchor on page load
  openModalFromHash();
});

// In-page links like <a href="#manage-donation">
window.addEventListener("hashchange", openModalFromHash);

// One-Click Buy (docs/one-click-buy.md): [data-one-click-buy] buttons, and
// #buy, open the pop-up when push-donations turns it on (PUSH_ONE_CLICK_BUY).
let oneClickBuyModulePromise = null;

function openOneClickBuy(triggerElement) {
  if (!window.PUSH_ONE_CLICK_BUY) return false;
  if (!oneClickBuyModulePromise) {
    oneClickBuyModulePromise = import("./one-click-buy/index.tsx");
  }
  oneClickBuyModulePromise.then((module) => module.open(triggerElement));
  return true;
}
// For the quick-add's Quick Buy (spektrix-quick-add.js).
window.openOneClickBuy = openOneClickBuy;

document.addEventListener("click", (e) => {
  const trigger = e.target.closest("[data-one-click-buy]");
  if (trigger && openOneClickBuy(trigger)) {
    e.preventDefault();
  }
});

if (window.location.hash === "#buy") {
  openOneClickBuy(null);
}

import "./accordions";
import "./show-ads";
import "./video-popup";
import "./spektrix-quick-add.js";
import "./sidescroll.ts";
import "./list-sharing";
import "./artist-bio";
import "./show-buybar";
import "./shortlist-count";
import "./newsletter-scroll-animation";
import "./audio-recorder";
import "./testimonials.ts";
import "./program-tabs";
import "./program-dates";
import "./program-quick-add";

/*!
 * jQuery Sieve v0.3.0 (2013-04-04)
 * http://rmm5t.github.com/jquery-sieve/
 * Copyright (c) 2013-2017 Ryan McGeary; Licensed MIT
 */
(function () {
  var e;
  (e = jQuery),
    (e.fn.sieve = function (t) {
      var n;
      return (
        (n = function (e) {
          var t, n, r, o;
          for (o = [], n = 0, r = e.length; r > n; n++) (t = e[n]), t && o.push(t);
          return o;
        }),
        this.each(function () {
          var r, o, i;
          return (
            (r = e(this)),
            (i = e.extend(
              {
                searchInput: null,
                searchTemplate: "<div><label>Search: <input type='text'></label></div>",
                itemSelector: "tbody tr",
                textSelector: null,
                toggle: function (e, t) {
                  return e.toggle(t);
                },
                complete: function () { },
              },
              t
            )),
            i.searchInput ||
            ((o = e(i.searchTemplate)), (i.searchInput = o.find("input")), r.before(o)),
            i.searchInput.on("keyup.sieve change.sieve", function () {
              var t, o;
              return (
                (o = n(e(this).val().toLowerCase().split(/\s+/))),
                (t = r.find(i.itemSelector)),
                t.each(function () {
                  var t, n, r, c, l, a, u;
                  for (
                    n = e(this),
                    i.textSelector
                      ? ((t = n.find(i.textSelector)), (l = t.text().toLowerCase()))
                      : (l = n.text().toLowerCase()),
                    r = !0,
                    a = 0,
                    u = o.length;
                    u > a;
                    a++
                  )
                    (c = o[a]), r && (r = l.indexOf(c) >= 0);
                  return i.toggle(n, r);
                }),
                i.complete()
              );
            })
          );
        })
      );
    });
}).call(this);

jQuery(function ($) {
  $(".box-office").on("scroll", function () {
    $(".overflow-hint").addClass("scrolled");
  });

  if ("ontouchstart" in window || window.navigator.msMaxTouchPoints > 0) {
    $("body").addClass("touch-only");
  }

  var cache = Math.floor(new Date().getTime() / (1000 * 60 * 15)); // refresh every 15 mins
  var fuse = null;
  var searchIndex = $.get("https://pushfestival.ca/festival-events/?json&" + cache).then(function (
    data
  ) {
    fuse = new Fuse(JSON.parse(data), {
      // include: ["score"],
      shouldSort: true,
      threshold: 0.6,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      keys: ["text"],
    });
  });

  var showSearch = function () {
    $(".search-modal").addClass("active");
    $(".search-modal").attr("aria-hidden", "false");
    $(".search-modal input").focus();
    $(".push-site--search").prop("tabindex", 0);
    $(".search-close").prop("tabindex", 0);
    if (typeof gtag !== "undefined") {
      gtag("event", "search-activated");
    }
    return false;
  };

  var hideSearch = function () {
    $(".results").removeClass("active");
    $(".push-site--search").prop("tabindex", -1);
    $(".search-close").prop("tabindex", -1);
    $(".search-modal").removeClass("active");
    $(".search-modal").removeClass("working");
    $(".search-modal").attr("aria-hidden", "true");
    $(".search-modal input").prop("value", "");
    $(".search-modal input").blur();
    const searchTrigger = document.querySelector("#searchform .trigger");
    if (searchTrigger) {
      searchTrigger.focus({ preventScroll: true });
    }
    $(".hint").show();
    $(".results").empty();
    return false;
  };

  // Close modal button
  $(".search-modal .search-close").on("click", function (e) {
    e.preventDefault();
    hideSearch();
  });

  // Safari holds onto the page state too well.
  $(window).bind("pageshow", function (event) {
    $(".search-modal").removeClass("working");
  });

  $("#searchform .trigger").on("click", showSearch);

  $(".show_title").focus(function () {
    var $this = $(this);
    $(window).on("keydown", function (e) {
      if (e.keyCode === 13 && $this.is(":focus")) {
        e.preventDefault();
        $this.click();
      }
    });
  });

  $("#searchform .trigger").on("click", showSearch);
  $("#searchform .trigger").on("keydown", function (e) {
    if (e.keyCode === 13) {
      showSearch();
    }
  });

  $(window).on("keydown", function (e) {
    if ($(e.target).closest("shortlist-widget").length) {
      return true;
    }

    // Esc. Before the input check below: the open modal has its search
    // input focused, so Esc never got this far.
    if (e.keyCode === 27 && $(".search-modal").hasClass("active")) {
      hideSearch();
      return true;
    }

    if ($(e.target).is("input, textarea")) {
      return true;
    }

    // A-Z
    if (
      ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 65 && e.keyCode <= 90)) &&
      e.metaKey === false &&
      e.ctrlKey === false &&
      e.altKey === false
    ) {
      $(".results.active").animate({ scrollTop: 0 }, "fast");
      if (typeof gtag !== "undefined") {
        gtag("event", "search-activated-keyboard");
      }
      showSearch();
    }
    // Stop tabbing when search is open
    if (e.keyCode === 9 && $(".search-modal").hasClass("active")) {
      if (!$(".results")[0].classList.contains("active")) {
        e.preventDefault();
        if (document.activeElement.classList.contains("search-close")) {
          document.querySelector(".push-site--search").focus();
        } else {
          document.querySelector(".search-close").focus();
        }
      }
    }

    // Refocus on last search item when tab above input
    if (document.activeElement.classList.contains("search-close")) {
      if (e.keyCode === 9 && e.shiftKey) {
        e.preventDefault();
        if (document.querySelector(".search-all-link")) {
          document.querySelector(".search-all-link").focus();
        }
      }
    }

    // Refocus on search input when tabbing past last item
    if (document.activeElement.classList.contains("search-all-link")) {
      if (e.keyCode === 9 && !e.shiftKey) {
        e.preventDefault();
        document.querySelector(".search-close").focus();
      }
    }

    // Up and Down / Tab and Shift+Tab
    if (
      e.keyCode === 38 ||
      e.keyCode === 40 ||
      e.keyCode === 9 ||
      (e.keyCode === 9 && e.shiftKey)
    ) {
      $results = $(".results .result");
      var index =
        $results.index($results.filter(".active")) + (e.keyCode === 38 || e.shiftKey ? -1 : 1);
      if (index >= 0 && index < $results.length) {
        $results.filter(".active").removeClass("active");
        $($results.get(index)).focus().addClass("active");
        return false;
      }

      // if reaches outside .results, remove active class
      if (e.keyCode === 9 && e.shiftKey && index < 0) {
        $results.filter(".active").removeClass("active");
      }

      // if reaches .search-all, prevent default tabbing
      if (e.keyCode === 9 && $(".search-all").hasClass("active")) {
        e.preventDefault();
      }
    }

    // Enter.
    if (e.keyCode === 13 && $(".results .result.active a").length > 0) {
      $(".search-modal").addClass("working");
      // $('.search-modal input').val('');
      setTimeout(function () {
        window.location = $(".results .result.active a").attr("href");
        // If on same page.
        if (
          window.location.href.replace(/#.*$/, "") ===
          $(".results .result.active a").attr("href").replace(/#.*$/, "")
        ) {
          $(".results").removeClass("active");
          $(".search-modal").removeClass("active");
          $(".push-site--search").prop("tabindex", -1);
          $(".search-close").prop("tabindex", -1);
          $(".search-modal").attr("aria-hidden", "true");
          $(".search-modal").removeClass("working");
          $(".search-modal input").blur();
          $("#searchform .trigger").focus();
        }
      }, 1);
    }
  });

  $(".search-modal").on("click", function (e) {
    if ($(e.target).hasClass("search-modal")) {
      hideSearch();
    }
  });

  $(".search-modal .results").on("hover", ".result", function () {
    $(".search-modal .results .active").removeClass("active");
    $(this).addClass("active");
  });

  var previous = "";
  $(".search-modal input").on("keyup", function (e) {
    // Make FF properly clear the search field.
    if (e.keyCode === 27 && $(".search-modal").hasClass("active")) {
      $(".search-modal input").val("");
    }

    $(".results").toggleClass("active", $(".search-modal input").val() !== "");

    if (previous !== $(".search-modal input").val()) {
      $(".hint").hide();
      previous = $(".search-modal input").val();
      $(".results").empty();
      searchIndex.then(function () {
        var results = fuse.search($(".search-modal input").val());
        var groups = {};
        results.forEach(function (result) {
          if (typeof groups[result.type] === "undefined") {
            groups[result.type] = [];
          }
          groups[result.type].push(result);
        });
        for (var group in groups) {
          if (groups.hasOwnProperty(group)) {
            $grouping = $('<div class="grouping"><h2>' + group + "</h2></div>").appendTo(
              ".results"
            );
            for (var i = 0; i < groups[group].length && i <= 5 - 1; i++) {
              var result = groups[group][i];
              $(
                '<div class="result"><a href="' +
                result.link +
                '" aria-label="' +
                group +
                " search item " +
                result.text +
                '">' +
                result.text +
                "</a></div>"
              ).appendTo($grouping);
            }
          }
        }
        $(
          '<div class="result search-all"><a href="/?s=' +
          previous +
          '" class="search-all-link"><strong>Search whole site for "' +
          previous +
          '"</strong></a></div>'
        ).appendTo(".results");
        // $(".results .result").first().addClass("active");
      });
    }
  });

  $(".js-collapsible-faq").click(function () {
    $(this).parents(".collapsible").toggleClass("active");
    return false;
  });

  if ($(".trailer").length > 0) {
    if (!!navigator.userAgent.match(/firefox|msie|trident/i)) {
      $(".trailer, .trailer .internal").css("transition", "none");
    }
    $("body").on("mousemove", function (e) {
      var distance = e.pageX / $(window).width();
      var shiftAmount = distance < 0.5 ? 0 : (distance - 0.5) / 0.5;
      $(".trailer").css(
        "transform",
        "translateX(-" + shiftAmount * 33 + "vw) rotateZ(" + (30 - shiftAmount * 20) + "deg)"
      );
      $(".trailer .internal").css("transform", "rotateZ(-" + (30 - shiftAmount * 20) + "deg)");
    });

    $(".trailer").hover(
      function () {
        $(".play-button .clicky").addClass("active");
      },
      function () {
        $(".play-button .clicky").removeClass("active");
      }
    );

    $(".trailer, .play-button .clicky").click(function () {
      if ($(window).width() >= 700) {
        $("#home-banner").addClass("play-video");
        $(".video-container .responsive-video").append(
          '<iframe width="560" height="315" src="https://www.youtube.com/embed/VFuH9qRkLqY?autoplay=1&controls=1&modestbranding=1&rel=0" frameborder="0" allowfullscreen></iframe>'
        );
        return false;
      } else {
        return true;
      }
    });

    $(".video-container .clicky").click(function () {
      $("#home-banner").removeClass("play-video");
      $(".video-container .responsive-video iframe").remove();
      return false;
    });

    $(window).on("keyup", function (e) {
      if (e.keyCode === 27 && $("#home-banner").hasClass("play-video")) {
        $("#home-banner").removeClass("play-video");
        $(".video-container .responsive-video iframe").remove();
      }
    });
  }

  $(".tabs").each(function () {
    $tabs = $(this);
    $tabs.find(".tab-switcher .tab").click(function () {
      var index = $tabs.find(".tab-switcher .tab").index($(this));
      $tabs.find(".tab-switcher .tab, .tab-content .tab").removeClass("active");
      $tabs
        .find(
          ".tab-switcher .tab:nth-child(" +
          (index + 1) +
          "), .tab-content .tab:nth-child(" +
          (index + 1) +
          ")"
        )
        .addClass("active");
    });
  });

  var sponsorHover = false;
  $(".supporters, .patrons").each(function () {
    var $this = $(this);
    setInterval(
      function () {
        if (!sponsorHover) {
          $this.find("li:last-child").prependTo($this);
        }
      },
      $this.hasClass("supporters") ? 2000 : 2500
    );
  });
  $(".supporters, .patrons").hover(
    function () {
      sponsorHover = true;
    },
    function () {
      sponsorHover = false;
    }
  );

  /**
   * All events calendar and grid.
   */
  $(".day").click(function () {
    // $('.event-grid[data-date="' + $(this).data('date') + '"]').toggleClass('filtered');
    $(this).toggleClass("active");
    $("#" + $(this).data("date")).slideToggle(filterDates);
  });

  $(".js-events-all").click(function () {
    $(".day").addClass("active");
    $(".event-grid").slideDown(filterDates);
    return false;
  });

  $(".js-events-none").click(function () {
    $(".day").removeClass("active");
    $(".event-grid").slideUp(filterDates);
    return false;
  });

  function filterDates() {
    $(".show-count").html($(".event-grid:visible .event-block:not(.filtered)").length);
    $(".no-dates").toggleClass("active", $(".event-grid:visible").length === 0);
  }

  $(".event-grid").click(function () {
    updateHash($(this).attr("id"));
    // Need to be careful about event bubbling, if you click on a link, don't go there yet.
    if (!$(this).hasClass("active")) {
      $(this).addClass("active");
      return false;
    }
  });

  $(".event-grid header").click(function () {
    var $parent = $(this).parent(".event-grid");
    // Need to be careful about event bubbling.
    if ($parent.hasClass("active")) {
      $parent.removeClass("active");
      return false;
    }
  });

  $(".js-toggle-list").click(function () {
    $(this).parents(".event-grid").addClass("table");
    $(this).parents(".view-toggle").find("a").removeClass("active");
    $(this).addClass("active");
    return false;
  });

  $(".js-toggle-grid").click(function () {
    $(this).parents(".event-grid").removeClass("table");
    $(this).parents(".view-toggle").find("a").removeClass("active");
    $(this).addClass("active");
    return false;
  });

  $(".view-more-btn").on("click", function () {
    $(".hidden-content").slideToggle("fast");
    $(this).toggleClass("active");
    $(this).text($(this).hasClass("active") ? "View Less" : "View More");
    return false;
  });

  // Donation Cards
  var offset = 6;

  var $todayNotches = $(".today-notch");
  var $todayCards = $(".today-card");
  var todayCards = [];

  var $monthlyNotches = $(".monthly-notch");
  var $monthlyCards = $(".monthly-card");
  var monthlyCards = [];

  function Card($elem, currentX, currentY) {
    this.$elem = $elem;
    this.currentX = currentX;
    this.currentY = currentY;
  }

  function addCards($elem, cardArray) {
    $elem.css({ "z-index": $elem.attr("data-index") });
    cardArray.push(new Card($elem, 0, 0));
  }

  function hoverNotches($notchArray, $this, cardArray) {
    var _id = $this.attr("data-index");

    var topY = 0;
    var topX = -480;
    var offsetY = topY;
    var offsetX = topX;

    if (
      ($notchArray === $todayNotches && $(".today-notches").hasClass("active")) ||
      $notchArray === $monthlyNotches
    ) {
      $notchArray.eq(_id - 1).addClass("current");
      $notchArray.not($notchArray.eq(_id - 1)).removeClass("current");

      $notchArray.slice(0, _id).addClass("active");
      $notchArray.slice(_id).removeClass("active");

      // set active card to top-left corner
      cardArray[_id - 1].$elem.css({ transform: "translateX(" + topX + "px)" });
      cardArray[_id - 1].currentX = topX;

      // show or shuffle lower card
      cardArray
        .slice(0, _id - 1)
        .reverse()
        .forEach(function (card) {
          offsetX += offset;
          offsetY += offset;
          card.currentX = offsetX;
          card.currentY = offsetY;
          card.$elem.css({
            transform: "translate(" + card.currentX + "px," + card.currentY + "px)",
          });
        });

      // remove higher card
      cardArray.slice(_id).forEach(function (card) {
        card.$elem.removeClass("active");
        card.isShowing = false;
        card.currentX -= card.currentX;
        card.currentY -= card.currentY;
        card.$elem.css({
          transform: "translate(" + card.currentX + "px," + card.currentY + "px)",
        });
      });
    }
  }

  $todayCards.each(function () {
    addCards($(this), todayCards);
  });
  $todayNotches.hover(function () {
    hoverNotches($todayNotches, $(this), todayCards);
  });
  $todayNotches.first().addClass("current active");

  $monthlyCards.each(function () {
    addCards($(this), monthlyCards);
  });
  $monthlyNotches.hover(function () {
    hoverNotches($monthlyNotches, $(this), monthlyCards);
  });
  $monthlyNotches.first().addClass("current active");
  if (monthlyCards.length > 0) {
    monthlyCards[0].$elem.css({ transform: "translateX(-480px)" });
  }

  // Donations Page
  $(".donate-tab").click(function () {
    if ($(this).attr("data-donate") === "today") {
      $(".donate-form-header-title").html("Donate Today");
      window.history.replaceState(null, null, window.location.pathname);
    } else if ($(this).attr("data-donate") === "monthly") {
      $(".donate-form-header-title").html("Donate Monthly");
      window.history.replaceState(null, null, "#" + $(this).attr("data-donate"));
    } else if ($(this).attr("data-donate") === "other") {
      $(".donate-form-header-title").html("Other Ways to Give");
      window.history.replaceState(null, null, "#" + $(this).attr("data-donate"));
    }
    $(this).toggleClass("active");
    $(".donate-tab").not($(this)).removeClass("active");
  });

  var url = window.location.href;
  if (url.indexOf("monthly") >= 0) {
    $('.donate-tab[data-donate="monthly"]').click();
  } else if (url.indexOf("other") >= 0) {
    $('.donate-tab[data-donate="other"]').click();
  } else {
    $('.donate-tab[data-donate="today"]').click();
  }

  $(".impact-button").click(function () {
    $(".donate-default").animate(
      {
        opacity: 0,
      },
      200,
      function () {
        $(".today-notches").addClass("active");
        $(".today-card").first().css({ transform: "translateX(-480px)" });
        $(".donate-default").hide();
        $(".donate-today-levels").animate(
          {
            opacity: 1,
          },
          200
        );
      }
    );
  });

  // Cookie manager
  if (Cookies.get("hasAcceptedCookieAgreement") !== "true") {
    $("#cookie-warning .button").click(function () {
      $("#cookie-warning").hide();
      Cookies.set("hasAcceptedCookieAgreement", true, { expires: 365 });
    });
    $("#cookie-warning").show();
  }
});

// UPDATE 2020 👇

// Update hash and open tab/accordion on click
jQuery(function ($) {
  // TABS
  $(".tab-block .tab").click(function () {
    var $parent = $(this).parent();
    var tabTarget = $(this).data("target");

    $parent.children(".tab").removeClass("active").attr("aria-selected", false);
    $(this).addClass("active").attr("aria-selected", true);

    $parent.children(".tab-content").removeClass("active").attr("aria-hidden", true);
    $parent
      .children('div[data-id="' + tabTarget + '"]')
      .addClass("active")
      .attr("aria-hidden", false);

    updateHash($(this).data("target"));

    return false;
  });
});

jQuery(function ($) {
  $(".event-details .push_button").click(function () {
    $("html, body").animate(
      {
        scrollTop: $("#tickets").offset().top - $("header").height() - $(".box-office").height(),
      },
      500
    );
    return false;
  });
});

// If hash is present, open tab/accordion on load and scroll to target
jQuery(function ($) {
  var $target;
  var $tabSection;
  var hash = decodeURIComponent(window.location.hash);

  if (hash !== "") {
    hash = hash[hash.length - 1] === "/" ? hash.substring(1, hash.length - 1) : hash.substring(1);
    $target = $('div[data-id="' + hash + '"]').first();

    if ($target.length) {
      // Found a tab or accordion
      var type = $target.hasClass("tab-content") ? "tab" : "accordion";

      if (type === "tab") {
        activateTab($target);
      } else {
        activateAccordion($target);
      }
    } else {
      // Either a performance or someone has linked incorrectly
      $target = $("div.event-grid#" + hash).first();

      if ($target.length) {
        activatePerformanceAccordion($target);
      }
    }
  }

  activateDefaultTabs();

  function activateTab($tab) {
    $tab.addClass("active");
    $('div[data-target="' + hash + '"]')
      .first()
      .addClass("active")
      .attr("aria-selected", true);

    $tabSection = $tab.parent(".tab-block");

    scrollToTarget($tab);
  }

  function activateDefaultTabs() {
    $firstTabs = $(".tab-block").not($tabSection).children(".tab:first-child");

    $firstTabs.each(function () {
      $(this).addClass("active");
      $('div[data-id="' + $(this).data("target") + '"]')
        .addClass("active")
        .attr("aria-hidden", false);
    });
  }

  function activateAccordion($accordion) {
    var targetInsideTab = $accordion.parents(".tab-content").length > 0;

    if (targetInsideTab) {
      $tabSection = $accordion.parents(".tab-block");

      $parent = $accordion.parent(".tab-content");
      $tab = $parent.prev();

      $parent.addClass("active");
      $tab.addClass("active");
    }

    var $button = $('div[data-target="' + hash + '"]').first();
    $button.addClass("active");

    $accordion.slideToggle("fast");
    scrollToTarget($accordion);
  }

  function activatePerformanceAccordion($accordion) {
    if ($accordion.hasClass("active")) {
      $accordion.removeClass("active");
    } else {
      $accordion.addClass("active");
    }

    scrollToTarget($accordion);
  }
});

function scrollToTarget($target) {
  jQuery("html, body").animate(
    {
      scrollTop: $target.offset().top - 300,
    },
    500
  );
}

export function updateHash($target) {
  if (window.history.pushState) {
    window.history.replaceState(null, null, "#" + $target);
  } else {
    window.location.hash = "#" + $target;
  }
}

// 2021 Update
jQuery(function ($) {
  var $sbwOuter = $("<div>")
    .css({
      visibility: "hidden",
      width: 100,
      overflow: "scroll",
    })
    .appendTo("body");
  var scrollBarWidth =
    100 - $("<div>").css({ width: "100%" }).appendTo($sbwOuter).outerWidth() + "px";
  $sbwOuter.remove();

  if ($(".filter-delegates").length > 0) {
    $(".page").sieve({
      itemSelector: ".industry-attendee",
      textSelector: "h3",
      searchInput: $(".filter-delegates input"),
    });
    // $('.filter-delegates input').on('keyup change', function() {
    //   console.log($(this).val())
    // });
  }
});

// 2023 Update
jQuery(function ($) {
  // TAB keyboard support
  $(".tab-block .tab").on("keydown", function (e) {
    if (e.key === "ArrowRight") {
      e.preventDefault();
      if ($(this).nextAll(".tab:first").length === 0) {
        $(this).siblings(".tab:first").focus();
      } else {
        $(this).nextAll(".tab:first").focus();
      }
    }
    if (e.key === "ArrowLeft") {
      e.preventDefault();
      if ($(this).prevAll(".tab:first").length === 0) {
        $(this).siblings(".tab:last").focus();
      } else {
        $(this).prevAll(".tab:first").focus();
      }
    }
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      $(this).click();
    }
    if (e.key === "ArrowDown" || (e.key === "Tab" && !e.shiftKey)) {
      e.preventDefault();
      $(this).nextAll(".tab-content.active").find("[tabindex=0]").first().focus();
    }
  });
});

window.addEventListener(
  "message",
  function (event) {
    // console.log('SCRIPTS-JS: Received postMessage event:', {
    //   origin: event.origin,
    //   data: event.data ? event.data.substring(0, 50) + '...' : event.data,
    //   type: typeof event.data
    // });
    if (event.origin == 'https://ticketing.purchase.pushfestival.ca' && event.data == 'scrollToTopPlz') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if (event.origin == 'https://ticketing.purchase.pushfestival.ca' && event.data.startsWith('scrollToPlz:')) {
      window.scrollTo({ top: parseFloat(event.data.split(':')[1]), behavior: 'smooth' });
    }
  },
  false
);
